export class ActivateDeactivateUserRoles {
    userRoleId: string;
    constructor(userRoleId: string) {
        this.userRoleId = userRoleId;
    }
}